module.exports = __webpack_public_path__ + "media/sms.b4b2a643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/sms.svg
// module id = ./src/templates/outSide/assets/img/sms.svg
// module chunks = 0